import React from 'react';
import './RydTestbedWrap.css';
import { Link } from 'react-router';
import { GlobalDataProvider } from '../GlobalDataContext';

interface RydTestbedWrapProps {
    children: React.ReactNode;
}

const RydTestbedWrap: React.FC<RydTestbedWrapProps> = ({ children }) => {
    return (
        <React.StrictMode>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/components/">Components Home</Link></li>
          </ul>

          <GlobalDataProvider>
            <div className={"ryd-testbed-background"}>
              {children}
            </div>
          </GlobalDataProvider>
        </React.StrictMode>
      )
};

/* utility function to be used directly on return statement of a testbed component, wrapping other elements. */
const wrap = (el:React.ReactNode) => {
    return (<RydTestbedWrap>{el}</RydTestbedWrap>);
  }

export {
    RydTestbedWrap,
    wrap
};